import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { DateTimeSegment } from "../date-time-segments";
import { ISO_FORMAT } from "./constants";
export function dateTimeSegmentsToDate(segmentValues, showSeconds, showMilliseconds) {
  var _ref = segmentValues,
      year = _ref.year,
      month = _ref.month,
      day = _ref.day,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds,
      milliseconds = _ref.milliseconds;
  var parsedDate = Date.UTC(year, month - 1, // Adjust month index
  day, hours, minutes, showSeconds ? seconds : 0, showMilliseconds ? milliseconds : 0);
  return new Date(parsedDate);
}
export var dateStringToSegments = function dateStringToSegments(dateString) {
  var date = new Date(dateString);
  return {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    // Adjust month index
    day: date.getUTCDate(),
    hours: date.getUTCHours(),
    minutes: date.getUTCMinutes(),
    seconds: date.getUTCSeconds(),
    milliseconds: date.getUTCMilliseconds()
  };
};
export var hasAnySegmentValue = function hasAnySegmentValue(segmentValues) {
  return Object.values(segmentValues).some(function (value) {
    return value !== undefined;
  });
};
export var isIsoFormat = function isIsoFormat(dateString) {
  return ISO_FORMAT.test(dateString);
};
export var buildValueStringId = function buildValueStringId(id) {
  return "".concat(id, "-value-string");
};
export var hasAllDateValues = function hasAllDateValues(segmentValues) {
  return [segmentValues[DateTimeSegment.Year], segmentValues[DateTimeSegment.Month], segmentValues[DateTimeSegment.Day]].every(function (value) {
    return value !== undefined;
  });
};
export var hasAnyTimeValue = function hasAnyTimeValue(segmentValues, showSeconds, showMilliseconds) {
  return [segmentValues[DateTimeSegment.Hours], segmentValues[DateTimeSegment.Minutes]].concat(_toConsumableArray(showSeconds ? [segmentValues[DateTimeSegment.Seconds]] : []), _toConsumableArray(showMilliseconds ? [segmentValues[DateTimeSegment.Milliseconds]] : [])).some(function (value) {
    return value !== undefined;
  });
};